import request from './adminRequest'

export const offeredCourseApi = {
  listOfferedCourse (params) {
    return request.get('/offeredCourses/', { params: params })
  },
}
export default offeredCourseApi
